<template>
  <div :key="blob.giftcard.id" class="absolute-fill elevation-8 gc-border" v-bind:class="{ black: !placeholder }">
    <div v-if="placeholder" class="absolute-fill placeholder" />

    <!-- The gift-of-choice gift card uses a special animation -->
    <video
      v-if="blob.giftcard.product_img == 'https://cdn.ellacard.com/giftcards_gift_of_choice.jpg'"
      class="user-select-none gc-border"
      playsinline autoplay muted loop draggable="false" width="100%"
      poster="//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.webp"
      src="//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.mp4"
      @loadedmetadata="onLoad"
      @error="onLoad"
    />
    <img v-else class="user-select-none gc-border" :src="blob.giftcard.product_img" @load="onLoad" draggable="false" />

  </div>
</template>

<style scoped>
img {
  pointer-events: none;
  width: 100%;
  height: 100%;
}
.placeholder {
  box-sizing: border-box;
  border: 4px dashed rgba(0, 0, 0, .1);
}
</style>

<script>
export default {
  name: 'giftcard-blob',

  props: [ 'blob' ],

  data() {
    return {
      placeholder: true
    };
  },

  methods: {
    onLoad() {
      this.placeholder = false;
      this.$emit('loaded');
    }
  }
}
</script>
